export default __webpack_public_path__ + "static/media/manutd2.d9ce287c.jpg";